import { IAddress } from '@shared/interfaces/address.interface';

export const buildAddress = (
  address: IAddress,
  _relationships: any,
  _included: any
): any => address;
